import { render, staticRenderFns } from "./BusPrices.vue?vue&type=template&id=24c24ca8&"
import script from "./BusPrices.vue?vue&type=script&lang=js&"
export * from "./BusPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports